module.exports = __webpack_public_path__ + "img/video_suspend.6a97b5df.png";